/* eslint-disable no-unused-vars */
import cn from 'classnames';
import React from 'react';

export enum RoundedVariant {
  FULL = 'full',
  LEFT = 'left',
  RIGHT = 'right',
  DIAGONAL = 'diagonal',
}

interface IProps {
  roundedVariant?: RoundedVariant;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  className?: string;
}

const classes = {
  root: 'flex content-center items-center justify-center',
  large: 'h-5 w-12 md:h-5 md:w-12 md:text-base',
  small: 'h-5 w-12 md:h-5 md:w-12 md:text-sm',
};

export const Tag = ({
  roundedVariant = RoundedVariant.FULL,
  size = 'medium',
  className,
  children,
}: React.PropsWithChildren<IProps>) => {
  const classesName = cn(
    classes.root,
    {
      [classes.large]: size === 'large',
      [classes.small]: size === 'small',
      'rounded-bl-md rounded-tr-md': roundedVariant === RoundedVariant.DIAGONAL,
      'rounded-l-md': roundedVariant === RoundedVariant.LEFT,
    },
    className,
  );
  return <div className={classesName}>{children}</div>;
};

export default Tag;
